/* ============================================================
   <subscription-line-toggle>
   Alterna um item do carrinho entre "Compra única" e "Mensal"
   trocando a variante de forma atômica via /cart/update.js
   (define a variante atual = 0 e a variante alvo = quantidade).

   Sobrevive ao re-render do drawer (Section Rendering API) porque
   é um custom element: o constructor/connectedCallback re-roda
   quando o HTML é re-injetado. Após o swap, dispara o mesmo evento
   do tema (action:cart:updateCart) para re-renderizar o drawer.

   Atributos esperados (renderizados pelo Liquid):
     data-current-variant  → id da variante atual do item
     data-target-variant   → id da variante de destino (Mensal/Compra)
     data-quantity         → quantidade atual do item
   ============================================================ */
(function () {
  if (customElements.get('subscription-line-toggle')) return;

  var CART_UPDATE_EVENT = 'action:cart:updateCart';
  var SECTIONS = 'cart-drawer,cart-count-bubble,cart-popup,manual-discount-codes';

  class SubscriptionLineToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sub-toggle]');
      if (!this.button) return;
      if (!this._onClick) this._onClick = this.handleClick.bind(this);
      // Idempotente: cobre re-render do drawer e moves no DOM sem duplo-bind.
      this.button.removeEventListener('click', this._onClick);
      this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button && this._onClick) {
        this.button.removeEventListener('click', this._onClick);
      }
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    handleClick() {
      if (this.getAttribute('aria-busy') === 'true') return;

      var current = this.getAttribute('data-current-variant');
      var target = this.getAttribute('data-target-variant');
      var quantity = parseInt(this.getAttribute('data-quantity'), 10) || 1;

      if (!current || !target || current === target) return;

      // Feedback otimista: inverte o estado visual na hora; a rede confirma depois.
      var btn = this.button;
      var willActivate = !btn.classList.contains('is-active');
      btn.classList.toggle('is-active', willActivate);
      btn.setAttribute('aria-pressed', willActivate ? 'true' : 'false');

      this.setAttribute('aria-busy', 'true');

      var updates = {};
      updates[current] = 0;
      updates[target] = quantity;

      fetch(this.root + 'cart/update.js?sections=' + SECTIONS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart update failed');
          return response.json();
        })
        .then(
          function (data) {
            // Reseta o estado de carregamento antes do re-render (rede lenta
            // não deixa o toggle inerte).
            this.removeAttribute('aria-busy');
            document.dispatchEvent(
              new CustomEvent(CART_UPDATE_EVENT, { detail: { sections: data.sections } })
            );
          }.bind(this)
        )
        .catch(
          function () {
            // Reverte o feedback otimista se a atualização falhar.
            btn.classList.toggle('is-active', !willActivate);
            btn.setAttribute('aria-pressed', !willActivate ? 'true' : 'false');
            this.removeAttribute('aria-busy');
          }.bind(this)
        );
    }
  }

  customElements.define('subscription-line-toggle', SubscriptionLineToggle);
})();
